/// <reference path="../../../typings/browser.d.ts" />

namespace Application.Controllers {
    'use strict';

    export interface ITsProbeModalScope extends ng.IScope {
        probes: ISelectableProbe[];
        selectedProbe: Models.TsProbe;

        getConnectedNetworks: (probe: Models.NetworkNode) => Models.INetwork[];
        getConnectedNetworksTooltip: (probe: Models.NetworkNode) => string;
        getSlotsInfo: (probe: Models.TsProbe) => string;
        modalClose: () => void;
        modalSave: (probe: ISelectableProbe) => void;
    }
    
    export interface ISelectableProbe {
        probe: Models.TsProbe;
        node: Models.NetworkNode;
    }

    export class TsProbeModalController {
        public static templateUrl: string = "decorators/modals/ts-probe-modal.html";
        public static ID: string = "#id-ts-probe-modal";
        public static $name: string = "tsProbeModalController";
        public static $inject: string[] = ['$scope', 'close', 'networkNodeService', 'networkNodeTypeService', 'tsProbeService', 'probe'];

        private $scope: ITsProbeModalScope;
        private close: (p: ISelectableProbe[]) => void;

        constructor($scope: ITsProbeModalScope,
                    close: (p: ISelectableProbe[]) => void,
                    networkNodeService: Services.NetworkNodeService,
                    networkNodeTypeService: Services.NetworkNodeTypeService,
                    tsProbeService: Services.TsProbeService,
                    probe: Models.ISelectableProbe,
                    selectedProbe: Models.TsProbe) {

            this.$scope = $scope;
            this.close = close;
            this.$scope.probes = [probe];
            this.$scope.selectedProbe = selectedProbe;

            this.$scope.getConnectedNetworks = (p: Models.NetworkNode): Models.Network[] => {
                let networks: Models.Network[] = [];
                if (p.networkInterfaces !== undefined && p.networkInterfaces.length > 0) {
                    for (let nic of p.networkInterfaces) {
                        if (nic.connected === true) {
                            networks.push(nic.networkConnectedTo as Models.Network);
                        }
                    }
                }
                return networks;
            };

            this.$scope.getSlotsInfo = (p: Models.TsProbe): string => {
                return (p.emptySlots === 1) ? `1 slot available of ${p.totalSlots}` : `${p.emptySlots} slots available of ${p.totalSlots}`;
            };

            this.$scope.modalClose = (): void => {
                this.close(undefined);
            };

            this.$scope.modalSave = (p: ISelectableProbe): void => {
                if (p !== undefined) {
                    this.$scope.selectedProbe = p.probe;
                    this.$scope.selectedProbe.defaultProbe = true;
                    this.close([p]);
                }
            };
        }
    }
}
